import { render, staticRenderFns } from "./TreinadorAlunos.vue?vue&type=template&id=1a56f242&scoped=true&"
import script from "./TreinadorAlunos.vue?vue&type=script&lang=js&"
export * from "./TreinadorAlunos.vue?vue&type=script&lang=js&"
import style0 from "./TreinadorAlunos.vue?vue&type=style&index=0&id=1a56f242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a56f242",
  null
  
)

export default component.exports